export interface Environment {
  production: boolean;
  application: string;
  apiUrl: string;
  mockUrl: string;
  instrumentationKey: string;
  sso: boolean;
  passKey: string;
  passValue: string;
  idleTime: number;
  logoutTime: number;
  ipKey: string,
  ProcessDocApiLimit: number,
  ProcessDocApiInterval: number
}
